import { useEffect, useMemo, useRef } from 'react';
import {
  Box,
  Text,
  Container,
  Flex,
  Heading,
  HStack,
  Stack,
  VStack,
  Button,
  Collapse,
  useRadioGroup,
  Input,
  InputGroup,
  InputLeftAddon,
  Textarea,
  FormControl,
  FormLabel,
  RadioGroup,
  Radio,
} from '@chakra-ui/react';
// import { useStateMachine } from 'little-state-machine';
import { Controller, useForm, useFormState } from 'react-hook-form';
import { httpsCallable } from 'firebase/functions';
import map from 'lodash/map'

import { responsive } from '../../contexts/responsive'

import NavHeading from '../NavHeading';
import PriceSelector from './PriceSelector';
import Terms from './Terms';
import ProjectHeading from './ProjectHeading';

import RadioInput from '../../components/FormField/RadioInput';
import RadioCard from '../../components/FormField/RadioCard';
import FormField from '../../components/FormField';
import Helper from '../../components/Helper';
import useFunctions from '../../hooks/useFunctions';

export { query } from '../portalQuery'

// const amtOptions = [50, 100, 200, 'custom']
const anonymousLable = {
  no: '自訂',
  yes: '匿名',
  // ig: 'IG帳號',
}
const anonymousOptions = ['no', 'yes']

const getClientId = () => new Promise(resolve => {
  window.gtag('get', 'client_id', resolve)
});

const timeout = (dur, res = '') => new Promise(resolve => {
  window.setTimeout(() => resolve(res), dur)
})

function getFbClientId() {
  const fbp = /_fbp=(fb\.\d\.\d+\.\d+)/.exec(window.document.cookie);
  const fbc = /_fbc=(fb\.\d\.\d+\.\w+)/.exec(window.document.cookie);
  return {
    fbp: fbp?.[1] ?? '',
    fbc: fbc?.[1] ?? '',
  }
}

const invoice = [
  // {
  //   name: 'needEmail',
  //   label: 'E-mail寄送',
  //   type: 'radio',
  //   rules: { required: true },
  //   options: [
  //     { value: 'yes', label: '需要' },
  //     { value: 'no', label: '不需要' },
  //   ],
  //   helper: '您需要E-mail收據嗎？',
  // },
  // {
  //   name: 'email',
  //   label: 'E-mail',
  //   placeholder: '請輸入您的 E-mail',
  //   type: 'email',
  //   rules: { required: true },
  //   when: ['needEmail', 'yes'],
  //   helper: '會寄送確認通知與神祕感謝圖唷~',
  // },
  {
    name: 'invoice',
    label: '發票類型',
    placeholder: '請選擇',
    options: [
      { value: 'donate', label: '捐贈發票' },
      { value: 'b2c', label: '二聯式發票' },
      { value: 'b2b', label: '三聯式發票' },
    ],
    type: 'select',
    rules: { required: true },
    helper: '所有支持金額都會開立統一發票',
  },
  {
    name: 'loveCode',
    label: '發票愛心碼',
    when: ['invoice', 'donate'],
    placeholder: '可指定，或預設7505(聯合勸募)',
    rules: { match: /^\d+$/ }
  },
  // {
  //   name: 'carrierNo',
  //   label: '載具條碼',
  //   when: ['invoice', 'b2c'],
  //   placeholder: '/ABCD123（可留空）',
  //   rules: { match: /^\/[A-Za-z0-9\s+-]{7}$/ }
  // },
  {
    name: 'company',
    label: '公司抬頭',
    when: ['invoice', 'b2b'],
    rules: { required: true }
  },
  {
    name: 'companyId',
    label: '公司統編',
    when: ['invoice', 'b2b'],
    rules: { match: /^\d{8}$/, required: true }
  },
]

const payment = {
  name: 'paymentMethod',
  label: '付款方式',
  options: [
    { value: 'credit', label: '信用卡' },
    { value: 'linepay', label: 'LINE Pay' },
  ],
  type: 'radio',
  rules: { required: true }
}


const SupportPage = (data) => {
  const functions = useFunctions();
  // const router = useRouter()
  const { setValue, register, watch, handleSubmit, control } = useForm({
    defaultValues: {
      paymentMethod: 'credit',
      anonymous: 'no',
      invoice: 'b2c',
      needEmail: 'yes',
    }
  });
  const formValues = watch()
  const ecpayFormRef = useRef()
  const { isSubmitting, errors } = useFormState({ control })
  const selectedProject = useMemo(() => {
    const project = Object.assign({}, map(data.support?.projects)[0])
    if (!project.prices) {
      project.prices = data.support?.prices
    }
    return project
  }, [data])
  const onSubmit = async formData => {
    const doCheckout = httpsCallable(functions, 'createOrder')
    const clientId = await Promise.race([
      getClientId(),
      timeout(50)
    ])
    const { fbp, fbc } = getFbClientId()
    const { data: res } = await doCheckout({
      ...formData,
      projectId: selectedProject.id ?? '0',
      id: data.firebaseId,
      location: window.location.href,
      clientId,
      fbp,
      fbc,
    })
    if (res.web) {
      setTimeout(() => {
        window.location = res.web
      })
    } else if (res.html && res.action) {
      ecpayFormRef.current.innerHTML = res.html
      ecpayFormRef.current.action = res.action
      ecpayFormRef.current.submit()
    }
  };
  const quickValue = formValues.quick
  const anonymousValue = formValues.anonymous
  const isNeedEmail = formValues.needEmail === 'yes'

  const {
    getRootProps: getAnonymousRootProps,
    getRadioProps: getAnonymousRadioProps,
  } = useRadioGroup({
    name: 'anonymous',
    onChange: value => setValue('anonymous', value),
    value: anonymousValue,
  })

  const anonymousGroup = getAnonymousRootProps()

  useEffect(() => {
    setValue('amount', quickValue === 'custom' ? '' : quickValue)
  }, [quickValue])

  useEffect(() => {
    setValue('name', anonymousValue !== 'yes' ? '' : '匿名')
  }, [anonymousValue])

  useEffect(() => {
    setValue('invoice', isNeedEmail ? 'b2c' : 'donate')
  }, [isNeedEmail])

  return (
    <Container py={responsive(4, 8)} minHeight="100%" as={Flex} flexDirection="column">
      <form id="_form_aiochk" ref={ecpayFormRef} method="POST" />
      <VStack
        width="full"
        alignItems="stretch"
        as="form"
        bg="white"
        p="2"
        flex="1"
        borderRadius="sm"
        boxShadow="sm"
        onSubmit={handleSubmit(onSubmit)}
      >
        <NavHeading data={data} />
        {selectedProject && (
          <ProjectHeading
            py="2"
            image={selectedProject.image}
            name={selectedProject.name}
            description={selectedProject.description}
          />
        )}
        <PriceSelector
          {...selectedProject}
          setValue={setValue}
          name="amount"
          quickValue={quickValue}
          control={control}
        />
        <FormControl as={VStack} p="2" alignItems="flex-start" spacing="2" isRequired>
          <FormLabel fontSize={responsive('1em')} mb="0">
            支持者名稱
          </FormLabel>
          {/* <Helper>會顯示給{data.name}</Helper> */}
          <HStack {...anonymousGroup} spacing="2">
            {anonymousOptions.map((value) => {
              const radio = getAnonymousRadioProps({ value })
              return (
                <RadioCard key={value} {...radio}>
                  {anonymousLable[value]}
                </RadioCard>
              )
            })}
          </HStack>
          <Box w="full">
            <Collapse in={anonymousValue !== 'yes'} animateOpacity>
              <Stack>
                <InputGroup>
                  <Input placeholder="姓名/暱稱" {...register('name', { required: true })} />
                </InputGroup>
                <InputGroup >
                  <InputLeftAddon bg="gray.50">@</InputLeftAddon>
                  <Input placeholder="IG帳號(選填)" {...register('igAccount')} isRequired={false} />
                </InputGroup>
              </Stack>
            </Collapse>
          </Box>
          {/* <Input type="email" placeholder="支持人信箱(必填)" {...register('email')} /> */}
        </FormControl>
        <VStack p="2" alignItems="flex-start" spacing="2">
          <Heading as="h2" fontWeight="500" fontSize={responsive('1em')}>
            留言給{data.name}
          </Heading>
          {/* <Helper>只有{data.name}才看得到</Helper> */}
          <Textarea {...register('message')} placeholder="(選填)" />
        </VStack>
        <VStack px="2" spacing="6">
          <FormControl as={Stack} spacing="2" isRequired>
            <FormLabel fontSize={responsive('1em')} mb="0">
              E-mail 寄送
            </FormLabel>
            <Helper>我們將寄送確認信，包含發票與感謝圖；若不希望收到信件，我們將捐贈發票。</Helper>
            <RadioInput
              control={control}
              name="needEmail"
              // eslint-disable-next-line react/no-children-prop
              children={[{ value: 'yes', label: '需要' }, { value: 'no', label: '不需要' }]}
            />
            {formValues.needEmail === 'yes' && (
              <Box pt="1">
                <Input placeholder="請輸入您的 E-mail" {...register('email', { required: true })} />
              </Box>
            )}
          </FormControl>
          {(isNeedEmail ? invoice : []).concat(payment).map((f) => (!f.when || formValues?.[f.when[0]] == f.when[1]) && (
            <Controller
              name={f.name}
              control={control}
              key={f.name}
              rules={f.rules}
              render={({ field, fieldState }) => (
                <FormField
                  bg="white"
                  {...f}
                  {...field}
                  fieldState={fieldState}
                />
              )}
            />
          ))}
        </VStack>
        <Box flex="1" />
        <Stack px="2" py="4" spacing={4}>
          <Button colorScheme="primary" isLoading={isSubmitting} isFullWidth type="submit">付款</Button>
          <Terms />
        </Stack>
      </VStack>
    </Container>
  );
}

export default SupportPage
